import { prospectDemoReferenceExecution } from "@clickdialog/solution-contract";
import type { DemoManifest } from "../../types";

const EXECUTION = prospectDemoReferenceExecution(
  "hospitality.accommodation.reference-pending",
);
if (!EXECUTION || EXECUTION.target.kind !== "unavailable") {
  throw new Error("hospitality_reference_execution_invalid");
}

export const HOSPITALITY_REFERENCE_PLACEHOLDER: DemoManifest = Object.freeze({
  id: "hospitality.accommodation.reference-pending",
  name: "Hospitality Reference — Direct Booking",
  vertical: "Hospitality",
  industryKey: "hospitality",
  industryLabel: "Hospitality",
  nicheKey: "accommodation",
  nicheLabel: "Accommodation",
  solutionKey: "direct-booking",
  solutionLabel: "Direct Booking",
  demoType: "reference",
  maturity: "missing",
  runtimeStatus: EXECUTION.runtimeStatus,
  status: "building",
  statusLabel: "Referencia pendiente",
  summary: "Slot canónico para la futura referencia Hospitality. La oferta comercial existe; la demo unificada todavía no.",
  scopeLabel: "Gap explícito · no es una demo ejecutable",
  capabilities: Object.freeze([
    "Website / direct-booking journey",
    "Booking Engine handoff",
    "Analytics / attribution",
    "Paid acquisition where justified",
  ]),
  launch: Object.freeze({
    kind: "unavailable",
    reason: EXECUTION.target.reason,
  }),
});
